/**
 * SEO component that queries for data with
 * Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/
 */

import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"

function Seo({ description, title, children }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description
  const defaultTitle = site.siteMetadata?.title

  return (
    <>
      <title>{defaultTitle ? `${title} | ${defaultTitle}` : title}</title>
      <link rel="preconnect" href="https://use.typekit.net/"></link>
      <link rel="stylesheet" href="https://use.typekit.net/npi5lpz.css"></link>
      <meta name="description" content={metaDescription} />
      <meta property="robots" content="noarchive" />
      <meta name="viewport" content="initial-scale=1,viewport-fit=cover,user-scalable=no" />
      <meta content="https://pfb-transforming-america.s3.us-east-2.amazonaws.com/PFB_GBIP_Social.jpg" property="og:image" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://infrastructure.peopleforbikes.org" />
      <meta name="twitter:card" content="summary_large_image"  />
      <meta name="twitter:creator" content={site.siteMetadata?.author || ``} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content="https://pfb-transforming-america.s3.us-east-2.amazonaws.com/PFB_GBIP_Social.jpg" key="twitterimg" />
      <meta name="twitter:site" content="@peopleforbikes" />
      <meta name="twitter:domain" content="peopleforbikes.org" />
      <link
        href="https://assets.website-files.com/61ef1ce781a9ccc3ef8bf926/61ef1ce781a9ccdaf18bf96a_pfb-logo-square-256px.png"
        rel="apple-touch-icon"
      />
      <link
        href="https://assets.website-files.com/61ef1ce781a9ccc3ef8bf926/61ef1ce781a9cc634e8bf966_pfb-icon.png"
        rel="shortcut icon"
        type="image/x-icon"
      />
      {children}
    </>
  )
}

export default Seo
